(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-compatibility-note"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const card = target?.closest('.product-compatibility');
    const details = card?.querySelector('.product-compatibility__details[open]');
    if (!details || target.closest('summary, a, button, input, select, textarea, label')) return;
    if (window.getSelection()?.toString()) return;
    const summary = details.querySelector('summary');
    summary?.click();
    summary?.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
